import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { GroupType } from '@libs/types/group.type';
import { DATA_LAYER, SESSION_STORAGE } from '@libs/shared/injections/window';
import { environment } from '@libs/environment';
import { SendEventHelper } from '@libs/helpers/send-event.helper';
import { IDataLayer } from '@libs/models/models';
import { VerificationType, VerificationTypeEnum } from '@libs/configs/component-configs/countdown.component-config';

@Component({
  selector: 'app-resend-sms-widget',
  templateUrl: `./templates/${environment.group}/page.html`,
  styleUrls: ['./resend-sms-widget.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResendSmsWidgetComponent {
  @Input()
  public showSignMessage: boolean;

  @Input()
  public showAuthMessage: boolean;

  @Input()
  public timeOut: boolean;

  @Input()
  public showPhone: boolean;

  @Input()
  public smsViber: boolean;

  @Input()
  public showIVR: boolean;

  @Input()
  public group: GroupType;

  @Input()
  public classes: string = '';

  @Input()
  public buttonPosition: 'column' | 'row' = 'column';

  @Input()
  public verificationType: VerificationType;

  @Input()
  public otherResendSmsLabel: string;

  @Input()
  public smsIcon: { url: string; height?: string; width?: string } | null = {
    url: './assets/images/icons/icon-repeat-sms.svg',
    width: '24px',
    height: '24px',
  };

  @Input()
  public otherResendSmsBntColor: string;

  @Output()
  public readonly verifyWayEvent: EventEmitter<VerificationType> = new EventEmitter<VerificationType>();
  public resendEvent: string;
  protected readonly VerificationTypeEnum = VerificationTypeEnum;

  constructor(
    @Inject(DATA_LAYER) private dataLayer: IDataLayer[],
    @Inject(SESSION_STORAGE) private sessionStorage: Storage,
    private eventHelper: SendEventHelper,
  ) {
    this.resendEvent = this.sessionStorage.getItem('resendEvent');
    this.sessionStorage.setItem('resendEvent', null);
  }

  public resend(type: VerificationType): void {
    this.eventHelper.send('clicked button of resend sms start method resend');
    this.sessionStorage.setItem('resendEvent', type as string);
    this.verifyWayEvent.emit(type);
    this.dataLayer.push({
      event: 'auth_funnel_phone_click_button_method',
      text: type === VerificationTypeEnum.PHONE ? 'Повторний дзвінок' : 'Отримати код в CMC',
      funnel_step: 'Step 1',
    });
  }
}
